import React, { useEffect } from 'react';
import { observer } from 'mobx-react';

import { useStableReactRouter } from 'context/stableReactRouterContext/stableReactRouterContext';
import { useAppStore } from 'hooks';

import Loader from '../Loader/Loader';

import styles from './MainLoader.module.scss';

function MainLoader() {
  const { location } = useStableReactRouter();
  const { appStore } = useAppStore();
  const { loadingBgColor } = appStore.dms || {};

  useEffect(() => {
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, [location.pathname]);

  if (loadingBgColor) {
    document.body.style.backgroundColor = loadingBgColor;
  }

  return (
    <div style={{ backgroundColor: `${loadingBgColor}` }} className={styles.wrapper}>
      <Loader />
    </div>
  );
}

export default observer(MainLoader);
